'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@awesome.me/kit-94e593bf23/icons/classic/light';
import { useCart } from '@/app/_lib/hooks/useCart';
import { useGlobalMessage } from '@/app/_lib/hooks';
import { useAppContext } from '@/app/_lib/_context';
const PromoCode = t0 => {
  const $ = _c(86);
  const {
    onPromotionChange,
    className
  } = t0;
  const {
    cart,
    promotion,
    applyPromotion,
    clearPromotion,
    isTradeCustomer
  } = useCart();
  const {
    openSignInModal
  } = useAppContext();
  const [promoCode, setPromoCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const inputRef = useRef(null);
  const addGlobalMessage = useGlobalMessage();
  let t1;
  let t2;
  if ($[0] !== onPromotionChange || $[1] !== promotion) {
    t1 = () => {
      if (onPromotionChange) {
        onPromotionChange(promotion);
      }
    };
    t2 = [promotion, onPromotionChange];
    $[0] = onPromotionChange;
    $[1] = promotion;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  const prevRequiresLogin = useRef(null);
  let t3;
  let t4;
  if ($[4] !== addGlobalMessage || $[5] !== promotion) {
    t3 = () => {
      if (prevRequiresLogin.current === true && promotion && !promotion.requires_login) {
        addGlobalMessage({
          message: "You are now signed in.",
          messageType: "success"
        });
      }
      prevRequiresLogin.current = promotion ? !!promotion.requires_login : null;
    };
    t4 = [promotion, addGlobalMessage];
    $[4] = addGlobalMessage;
    $[5] = promotion;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[8] !== isExpanded || $[9] !== promotion) {
    t5 = () => {
      if (isExpanded && !promotion && inputRef.current) {
        setTimeout(() => {
          inputRef.current?.focus();
        }, 100);
      }
    };
    t6 = [isExpanded, promotion];
    $[8] = isExpanded;
    $[9] = promotion;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  useEffect(t5, t6);
  if (isTradeCustomer) {
    return null;
  }
  let t7;
  if ($[12] !== addGlobalMessage || $[13] !== applyPromotion || $[14] !== promoCode) {
    t7 = async e => {
      e.preventDefault();
      if (!promoCode.trim()) {
        setError("Please enter a promotion code.");
        return;
      }
      setIsLoading(true);
      const response = await applyPromotion(promoCode.trim());
      if (response.success) {
        setPromoCode("");
        setIsExpanded(false);
        addGlobalMessage({
          message: "Promotion code applied!",
          messageType: "success"
        });
      } else {
        setError(response.message || "Promotion code not valid.");
      }
      setIsLoading(false);
    };
    $[12] = addGlobalMessage;
    $[13] = applyPromotion;
    $[14] = promoCode;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const handleSubmit = t7;
  let t8;
  if ($[16] !== addGlobalMessage || $[17] !== clearPromotion) {
    t8 = async () => {
      setIsLoading(true);
      const success = await clearPromotion();
      if (success) {
        setError("");
        addGlobalMessage({
          message: "Promotion code removed.",
          messageType: "success"
        });
      }
      setIsLoading(false);
    };
    $[16] = addGlobalMessage;
    $[17] = clearPromotion;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const handleRemove = t8;
  let t9;
  if ($[19] !== isExpanded) {
    t9 = () => {
      setIsExpanded(!isExpanded);
      setError("");
    };
    $[19] = isExpanded;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const toggleExpanded = t9;
  const showCollapsed = !promotion && !isExpanded;
  const showExpanded = !promotion && isExpanded;
  const showApplied = !!promotion;
  const t10 = `relative ${className || ""}`;
  const t11 = `transition-opacity duration-300 ${showCollapsed ? "opacity-100" : "opacity-0 absolute inset-0 pointer-events-none"}`;
  let t12;
  if ($[21] !== toggleExpanded) {
    t12 = <button type="button" onClick={toggleExpanded} className="text-sm text-ink-light-gray-bg underline hover:text-dark">Apply Promotion Code</button>;
    $[21] = toggleExpanded;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t11 || $[24] !== t12) {
    t13 = <div className={t11}>{t12}</div>;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = `transition-opacity duration-700 ${showExpanded ? "opacity-100" : "opacity-0 absolute inset-0 pointer-events-none"}`;
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = e_0 => setPromoCode(e_0.target.value);
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== isLoading || $[28] !== promoCode) {
    t16 = <input ref={inputRef} type="text" id="promo_code_input" value={promoCode} onChange={t15} className="material-input peer pr-8" placeholder=" " disabled={isLoading} />;
    $[27] = isLoading;
    $[28] = promoCode;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <label htmlFor="promo_code_input" className="material-input-label peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:!text-ink-light-gray-bg peer-not-placeholder-shown:material-input-label-float">Promotion Code</label>;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== isLoading) {
    t18 = isLoading ? <FontAwesomeIcon icon={faSpinnerThird} className="animate-spin" /> : "Apply";
    $[31] = isLoading;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== isLoading || $[34] !== t18) {
    t19 = <button type="submit" disabled={isLoading} className="absolute right-0 top-1/2 -translate-y-1/2 text-xs text-ink-light-gray-bg hover:text-primary transition-colors disabled:opacity-50">{t18}</button>;
    $[33] = isLoading;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t16 || $[37] !== t19) {
    t20 = <div className="material-input-group">{t16}{t17}{t19}</div>;
    $[36] = t16;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== handleSubmit || $[40] !== t20) {
    t21 = <form onSubmit={handleSubmit}>{t20}</form>;
    $[39] = handleSubmit;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  const t22 = `text-red text-xs transition-opacity duration-200 ${error ? "opacity-100" : "opacity-0"}`;
  const t23 = error || "\xA0";
  let t24;
  if ($[42] !== t22 || $[43] !== t23) {
    t24 = <span className={t22}>{t23}</span>;
    $[42] = t22;
    $[43] = t23;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== toggleExpanded) {
    t25 = <button type="button" onClick={toggleExpanded} className="text-xs text-ink-light-gray-bg underline hover:text-dark">Cancel</button>;
    $[45] = toggleExpanded;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== t24 || $[48] !== t25) {
    t26 = <div className="flex items-end justify-between mt-1">{t24}{t25}</div>;
    $[47] = t24;
    $[48] = t25;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== t14 || $[51] !== t21 || $[52] !== t26) {
    t27 = <div className={t14}>{t21}{t26}</div>;
    $[50] = t14;
    $[51] = t21;
    $[52] = t26;
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  const t28 = `transition-opacity duration-300 ${showApplied ? "opacity-100" : "opacity-0 absolute inset-0 pointer-events-none"}`;
  let t29;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <span className="text-sm font-medium">Promotion Code:</span>;
    $[54] = t29;
  } else {
    t29 = $[54];
  }
  const t30 = promotion?.promotion_code;
  let t31;
  if ($[55] !== t30) {
    t31 = <div>{t29}<span className="text-sm ml-1 uppercase">{t30}</span></div>;
    $[55] = t30;
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  let t32;
  if ($[57] !== isLoading) {
    t32 = isLoading ? <FontAwesomeIcon icon={faSpinnerThird} className="animate-spin" /> : "remove";
    $[57] = isLoading;
    $[58] = t32;
  } else {
    t32 = $[58];
  }
  let t33;
  if ($[59] !== handleRemove || $[60] !== isLoading || $[61] !== t32) {
    t33 = <button type="button" onClick={handleRemove} className="text-xs text-ink-light-gray-bg underline hover:text-dark transition-colors" disabled={isLoading}>{t32}</button>;
    $[59] = handleRemove;
    $[60] = isLoading;
    $[61] = t32;
    $[62] = t33;
  } else {
    t33 = $[62];
  }
  let t34;
  if ($[63] !== t31 || $[64] !== t33) {
    t34 = <div className="flex items-center justify-between">{t31}{t33}</div>;
    $[63] = t31;
    $[64] = t33;
    $[65] = t34;
  } else {
    t34 = $[65];
  }
  let t35;
  if ($[66] !== cart || $[67] !== promotion) {
    t35 = promotion?.messages && promotion.messages.length > 0 && <div className="mt-1">{promotion.messages.map((message, index) => {
        const isDiscountAppliedMessage = message.toLowerCase().includes("discount applied");
        if (isDiscountAppliedMessage && (!cart?.discount || cart.discount === 0)) {
          return null;
        }
        return <div key={index} className={`text-xs ${promotion.requires_login ? "text-light" : "text-green-600"}`}>{message}</div>;
      })}</div>;
    $[66] = cart;
    $[67] = promotion;
    $[68] = t35;
  } else {
    t35 = $[68];
  }
  let t36;
  if ($[69] !== cart?.hasSaleItems || $[70] !== promotion) {
    t36 = promotion && !promotion.requires_login && cart?.hasSaleItems && <div className="mt-1 text-xs text-red lowercase">some items in your cart do not qualify for the promotion</div>;
    $[69] = cart?.hasSaleItems;
    $[70] = promotion;
    $[71] = t36;
  } else {
    t36 = $[71];
  }
  let t37;
  if ($[72] !== openSignInModal || $[73] !== promotion?.requires_login) {
    t37 = promotion?.requires_login && <div className="mt-1 text-xs text-light"><button type="button" onClick={openSignInModal} className="underline text-primary">Sign in</button> to apply this discount.</div>;
    $[72] = openSignInModal;
    $[73] = promotion?.requires_login;
    $[74] = t37;
  } else {
    t37 = $[74];
  }
  let t38;
  if ($[75] !== t28 || $[76] !== t34 || $[77] !== t35 || $[78] !== t36 || $[79] !== t37) {
    t38 = <div className={t28}>{t34}{t35}{t36}{t37}</div>;
    $[75] = t28;
    $[76] = t34;
    $[77] = t35;
    $[78] = t36;
    $[79] = t37;
    $[80] = t38;
  } else {
    t38 = $[80];
  }
  let t39;
  if ($[81] !== t10 || $[82] !== t13 || $[83] !== t27 || $[84] !== t38) {
    t39 = <div className={t10}>{t13}{t27}{t38}</div>;
    $[81] = t10;
    $[82] = t13;
    $[83] = t27;
    $[84] = t38;
    $[85] = t39;
  } else {
    t39 = $[85];
  }
  return t39;
};
export default PromoCode;